import React, { useEffect, useState, useRef } from "react";
import EnhanceTable from "../../table/table";
import {
  Button,
  TextField,
  Grid,
  Typography,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import AdminModal from "../../modal/adminModal";
import Snackbar from "../../snackbar/snackbar";
import { getData, postData, currentDate, updateData } from "../../actions";
import csv from "papaparse";
import GetAppIcon from "@material-ui/icons/GetApp";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import FileDownload from "js-file-download";
import json2csv from "json2csv";
import axios from "axios";
const convertToCSV = json2csv.parse;

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  confirm: {
    zIndex: 999,
  },
  conFirmLabel: {
    fontWeight: "bold",
  },
}));

const UpdateModal = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [codeField, setCodeField] = useState();
  const [nameField, setNameField] = useState();
  const [vatSelected, setVatSelected] = useState("X1");
  const [snackbar, setSnackbar] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [wtaxSelected, setWtaxSelected] = useState("");

  useEffect(() => {
    async function loadIt() {
      if (props.wow) {
        await getData(`/vendors/wtaxcode/${props.wow.bpCode}`)
          .then((wTaxCode) => {
            setCodeField(props.wow.bpCode);
            setNameField(props.wow.bpName);
            setVatSelected(props.wow.vatType);
            setWtaxSelected(
              props.wtaxes.filter((item) => item.wTaxCode === wTaxCode)[0]
            );
          })
          .catch((error) => {
              
          });
      }
    }
    loadIt().finally(() => {
      setIsLoading(false);
    });
  }, []);

  const updateVendor = async () => {
    setIsLoading(true);
    setConfirmModal(false);
    updateData("/vendors/edit", {
      bpCode: codeField.trim(),
      bpName: nameField.trim(),
      vatType: vatSelected,
      wTaxCode: wtaxSelected.wTaxCode
        ? wtaxSelected.wTaxCode
        : wtaxSelected.split("➡")[0],
    })
      .then(() => {
        
        setIsLoading(false);
        setConfirmModal(false);
        props.handleClose(codeField)
      })
      .catch((error) => {
          
        props.handleClose("Cancel");
        setIsLoading(false);
      });
  };
  const confirm = (
    <>
      <Dialog className={classes.confirm} open={confirmModal}>
        <DialogTitle>Confirm Vendor Details</DialogTitle>
        <DialogContent>
          <Typography>
            Vendor Code:{" "}
            <span className={classes.conFirmLabel}>{codeField}</span>
          </Typography>
          <Typography>
            Vendor Name:{" "}
            <span className={classes.conFirmLabel}>{nameField}</span>
          </Typography>
          <Typography>
            Vat Type:{" "}
            <span className={classes.conFirmLabel}>{vatSelected}</span>
          </Typography>
          <Typography>
            Withholding Tax:{" "}
            <span className={classes.conFirmLabel}>
              {wtaxSelected.wTaxCode
                ? `${wtaxSelected.wTaxCode}➡ ${wtaxSelected.wTaxDisplayName}`
                : { wtaxSelected }}
            </span>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            disabled={isLoading}
            onClick={() => setConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button
            color="secondary"
            variant="contained"
            disabled={isLoading}
            onClick={() => updateVendor()}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
  const handleCloseThis = () => {
    props.handleClose("Cancel")
  }
  return (
    <>
      {confirm}
      {isLoading ? (
        <Backdrop className={classes.backdrop} open={isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <AdminModal
          title="Update Vendor Details"
          open={props.open}
          handleClose={handleCloseThis}
        >
          {!confirmModal ? (
            <div style={{ width: "100%", maxWidth: "400px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    type="text"
                    variant="outlined"
                    size="small"
                    disabled
                    value={props.wow.bpCode}
                    onChange={(e) => {
                      setCodeField(e.target.value);
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    variant="outlined"
                    label={"Vendor Name"}
                    size="small"
                    disabled={isLoading}
                    value={nameField ? nameField : ""}
                    onChange={(e) => {
                      setNameField(e.target.value);
                    }}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    id="vatType"
                    options={["X1", "IVAT-S", "IVAT-G", "IVAT-I", "DIV-S"]}
                    getOptionLabel={(option) => option}
                    fullWidth
                    required
                    defaultValue={props.wow.vatType}
                    onChange={(event, value) => setVatSelected(value)}
                    disabled={isLoading}
                    // inputValue={vatSelected}
                    // onInputChange={(x, inputValue) => setVatSelected(inputValue)}
                    onBlur={() => {
                      if (!vatSelected) {
                        setVatSelected(props.wow.vatType);
                      }
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Vat Type"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    id="wtaxOptions"
                    required
                    options={props.wtaxes}
                    defaultValue={wtaxSelected}
                    getOptionLabel={(option) =>
                      `${option.wTaxCode}➡ ${option.wTaxDisplayName}`
                    }
                    fullWidth
                    disabled={isLoading}
                    onChange={(event, value) => setWtaxSelected(value)}
                    // inputValue={wtaxSelected}
                    // onInputChange={(e, inputValue) => setWtaxSelected(inputValue)}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"Withholding Tax"}
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Button
                    type="submit"
                    color="primary"
                    style={{ float: "right" }}
                    onClick={() => {
                      setConfirmModal(true);
                    }}
                    disabled={isLoading}
                  >
                    Update
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : (
            ""
          )}
        </AdminModal>
      )}
    </>
  );
};

export default UpdateModal;
